// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
  position: relative;
}

.search-form {
  width: 100%;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.search-select {
  flex: 0 0 100px;
  height: 44px;
}

.search-wrapper {
  position: relative;
  flex: 1 1 auto;
  /* ocupa o restante da linha */
  min-width: 0;
  /* permite encolher sem quebrar */
}

.search-wrapper input {
  width: 100%;
  height: 44px;
  padding: 0 38px 0 14px;
  /* espaço para a lupa */
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  background: var(--ui-input-bg);
  color: var(--ui-text);
  outline: none;
  box-sizing: border-box;
}

.search-wrapper .search-icon {
  position: absolute;
  background-color: transparent;
  color: var(--ui-primary);
  font-size: 18px;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

/* Resultados da busca */
.social-search-results {
  position: absolute;
  left: 0;
  right: 0;
  /* mesma largura do input */
  top: calc(100% + 6px);
  /* abaixo do input */
  max-height: 280px;
  overflow: auto;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  box-shadow: var(--ui-shadow-sm);
  z-index: 50;
}

/* Itens da lista de resultados */
.social-search-result-item {
  padding: 10px 12px;
  font-size: 14px;
  color: var(--ui-text);
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.social-search-result-item:hover {
  background-color: #f5f8ff;
}

.search-result-loading {
  cursor: default;
}

.search-result-loading:hover {
  background-color: transparent;
}

.search-result-loading .skeleton-stack {
  padding: 2px;
}

.search-result-loading .skeleton-text {
  font-size: 12px;
}

.search-result-loading .skeleton-line {
  height: 10px;
}

.search-result-empty {
  color: #6b7280;
  cursor: default;
}

.search-result-empty:hover {
  background-color: transparent;
}

/* Responsividade */
@media (max-width: 640px) {
  .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .search-select {
    flex-basis: auto;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchInternal/SearchInternal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":[".search-container {\n  position: relative;\n}\n\n.search-form {\n  width: 100%;\n}\n\n.search-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n}\n\n.search-select {\n  flex: 0 0 100px;\n  height: 44px;\n}\n\n.search-wrapper {\n  position: relative;\n  flex: 1 1 auto;\n  /* ocupa o restante da linha */\n  min-width: 0;\n  /* permite encolher sem quebrar */\n}\n\n.search-wrapper input {\n  width: 100%;\n  height: 44px;\n  padding: 0 38px 0 14px;\n  /* espaço para a lupa */\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  background: var(--ui-input-bg);\n  color: var(--ui-text);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.search-wrapper .search-icon {\n  position: absolute;\n  background-color: transparent;\n  color: var(--ui-primary);\n  font-size: 18px;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/* Resultados da busca */\n.social-search-results {\n  position: absolute;\n  left: 0;\n  right: 0;\n  /* mesma largura do input */\n  top: calc(100% + 6px);\n  /* abaixo do input */\n  max-height: 280px;\n  overflow: auto;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  box-shadow: var(--ui-shadow-sm);\n  z-index: 50;\n}\n\n/* Itens da lista de resultados */\n.social-search-result-item {\n  padding: 10px 12px;\n  font-size: 14px;\n  color: var(--ui-text);\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.social-search-result-item:hover {\n  background-color: #f5f8ff;\n}\n\n.search-result-loading {\n  cursor: default;\n}\n\n.search-result-loading:hover {\n  background-color: transparent;\n}\n\n.search-result-loading .skeleton-stack {\n  padding: 2px;\n}\n\n.search-result-loading .skeleton-text {\n  font-size: 12px;\n}\n\n.search-result-loading .skeleton-line {\n  height: 10px;\n}\n\n.search-result-empty {\n  color: #6b7280;\n  cursor: default;\n}\n\n.search-result-empty:hover {\n  background-color: transparent;\n}\n\n/* Responsividade */\n@media (max-width: 640px) {\n  .search-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .search-select {\n    flex-basis: auto;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
